/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateTradingChallengeOptions,
  CreateTradingChallengeStatus201,
  CreateTradingChallengeStatus400,
  CreateTradingChallengeStatus409,
  CreateTradingChallengeStatus500,
} from '../types/CreateTradingChallenge'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createTradingChallenge } from '../clients/createTradingChallenge'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createTradingChallengeMutationKey = () => [{ url: '/v1/trading_challenges' }] as const

export function createTradingChallengeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createTradingChallengeMutationKey()
  return mutationOptions<
    CreateTradingChallengeStatus201,
    ResponseErrorConfig<
      | CreateTradingChallengeStatus400
      | CreateTradingChallengeStatus409
      | CreateTradingChallengeStatus500
    >,
    CreateTradingChallengeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createTradingChallenge({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Create a new trading challenge. Allowed for ADMIN and INTEGRATOR only.
 * @summary Create a trading challenge
 * {@link /v1/trading_challenges}
 */
export function useCreateTradingChallenge<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateTradingChallengeStatus201,
      ResponseErrorConfig<
        | CreateTradingChallengeStatus400
        | CreateTradingChallengeStatus409
        | CreateTradingChallengeStatus500
      >,
      CreateTradingChallengeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createTradingChallengeMutationKey()

  const baseOptions = createTradingChallengeMutationOptions(config) as UseMutationOptions<
    CreateTradingChallengeStatus201,
    ResponseErrorConfig<
      | CreateTradingChallengeStatus400
      | CreateTradingChallengeStatus409
      | CreateTradingChallengeStatus500
    >,
    CreateTradingChallengeOptions,
    TContext
  >

  return useMutation<
    CreateTradingChallengeStatus201,
    ResponseErrorConfig<
      | CreateTradingChallengeStatus400
      | CreateTradingChallengeStatus409
      | CreateTradingChallengeStatus500
    >,
    CreateTradingChallengeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateTradingChallengeStatus201,
    ResponseErrorConfig<
      | CreateTradingChallengeStatus400
      | CreateTradingChallengeStatus409
      | CreateTradingChallengeStatus500
    >,
    CreateTradingChallengeOptions,
    TContext
  >
}
